<template>
  <div class="content">
    <div :class="{bg: true,empty: list.length == 0}">
      <div class="batch">
        <img :src="checkedAll ? checkerOn : checker" class="checker" alt="checker" @click="selectAllChecker()">
        <div class="bigBtn greenBtn" @click="approveChecks()">
          批量通过
        </div>
        <div class="bigBtn" @click="banChecks()">
          批量退回
        </div>
      </div>

      <empty :mTop="50" class="empty" :msg="`暂无${$_syscfg.publish}数据`" v-if="list && list.length === 0 && !waiting" />
      <skeleton v-show="waiting"></skeleton>
      <div v-show="!waiting" class="items" v-for="(publish, i) in list" :key="i">
        <img v-if="publish.has_warning" src="@assets/img/common/warnTag.svg" alt="warn" class="warning">
        <div class="item">
          <img :src="publish.checked? checkerOn :checker" class="checker" alt="checker" @click="selectChecker(publish)">
          <div class="pic" @click="viewMedia(publish)">
            <img @error="imgError(publish)" class="main" :src="publish.img_url" alt="pic" v-if="publish.img_url">
            <img class="main" src="@assets/img/common/default.png" alt="default" v-if="!publish.img_url">
            <img v-if="publish.play_icon - 0 === 1 && publish.img_url" class="play" src="@assets/img/index/play.svg" alt="play">
          </div>
          <div class="article">
            <div class="title" @click="handleGo(publish)">
              <p class="tag" v-if="publish.status == '0'">{{publish.status_name}}</p>
              <p class="words" :title="publish.title">
                {{publish.title}}
              </p>
              <img src="@assets/img/common/tips.svg" alt="change" v-if="publish.has_change - 0 === 1">
              <img src="@assets/img/common/new.svg" alt="new" v-if="publish.is_new - 0 === 1">
              <img src="@assets/img/common/imgIcon.svg" alt="img" v-if="publish.has_img - 0 === 1">
              <img src="@assets/img/common/videoIcon.svg" alt="video" v-if="publish.has_video - 0 === 1">
              <img src="@assets/img/common/audioIcon.svg" alt="audio" v-if="publish.has_sound - 0 === 1">
              <!-- todo 22 -->
              <img alt="技审未通过" title="技审未通过" class="verify-logo" v-if="publish.has_audit&&publish.has_audit==2" src="@assets/img/common/verify-fail.svg">
            </div>
            <p class="content">
              {{publish.content}}
            </p>
            <div class="footline zz">
              <p class="mark">
                <img src="@assets/img/common/zz.svg" alt="time">
                <span>{{publish.user_name}}</span>
              </p>
              <p class="mark addTime">
                <img src="@assets/img/index/time.svg" alt="time">
                <span>{{publish.add_time}}</span>
              </p>
              <p class="mark caiyong">
                <img src="@assets/img/index/platform.svg" alt="tv">
                <span v-for="(c,i) in publish.column_info" :key="i">
                  {{`${c.ftitle ? c.ftitle : ""} ${c.stitle ? c.stitle : ""  } ${c.ttitle ? c.ttitle : ""}`}}
                </span>
              </p>
            </div>
          </div>
          <div class="handles">
            <div class="handle s" v-if="!!publish.preview_url" @click="goPublish(publish.preview_url)">
              预览
            </div>
            <div class="handle s" @click="goEdit(publish.publish_id)">
              编辑
            </div>
            <div class="handle greenBtn s" @click="upload(publish.publish_id)">
              通过
            </div>
            <div class="handle s" @click="sendBack(publish.publish_id)">
              退回
            </div>
          </div>
        </div>
      </div>
      <pages :page_count="page.pageCount" :index="page.pageIndex" :total="page.total" />
    </div>
  </div>
</template>

<script>
import pages from "@components/pages";
import common from "@common/common";
import { apis } from "@common/config";
import empty from "@components/empty";
import skeleton from "@components/skeleton";

export default {
  name: "checkInterviews",
  components: {
    pages,
    empty,
    skeleton
  },
  data() {
    return {
      waiting: true,
      isXnew: this.$store.state.isXnew,
      page: {
        pageIndex: 1,
        pageCount: 0,
        pageSize: 10,
        total: 0
      },
      checkedAll: false,
      checker: require("@assets/img/interview/checker.svg"),
      checkerOn: require("@assets/img/interview/checkerOn.svg"),
      list: [],
      searchOptions: {}
    };
  },
  methods: {
    imgError(i) {
      i.img_url = require('@assets/img/common/default.png')
    },
    async goEdit(i) {
      const newWindow = window.open();
      common.checkPageStatus(i, 2).then(r => {
        if (r) {
          newWindow.location.href = `${window.location.origin
            }/editPublish?d=${i}`;
        } else {
          newWindow.close();
        }
      });
    },
    async goPublish(i) {
      if (!i) return;

      await this.$audit(i);
    },
    //点击图片弹框
    async viewMedia(item) {
      let list = await common.myFetch(apis.File_status, {
        subject_id: item.publish_id,
        subject_type: 2
      })
      common.openMaterialBox(list, null, false);
    },
    //点击跳转链接
    handleGo(i) {
      const s = i.status;
      this.$set(i, "has_change", 0);
      this.$set(i, "is_new", 0);

      if (s == 0) {
        this.goEdit(i.publish_id);
      } else {
        this.goDetail(i.publish_id);
      }
    },
    goDetail(i) {
      common.jump(`/publishDetail?d=${i}&c=t`, true);
    },
    getList(keyWord) {
      // 获取列表数据
      this.waiting = true;
      const info = {
        pagesize: this.page.pageSize,
        page: this.page.pageIndex,
        search_option: "",
        key_words: "",
        status: ""
      };

      if(keyWord == 'noKeyWord'){
        this.searchOptions.key_words = ''
      }else{  
        this.searchOptions.key_words = this.$store.state.keyWord
      }

      Object.assign(info, this.searchOptions, this.filterOptions);

      common.myFetch(apis.publishVerifylist, info).then(res => {
        console.log(res, 123456);
        if (res) {
          this.list = res.list;
          this.generateSearchs(res.params.top_search.option.list);
          this.$set(
            this.page,
            "pageCount",
            common.calculatePage(res.page.row_count - 0, this.page.pageSize)
          );
          this.$set(this.page, "total", res.page.row_count - 0);
          this.showCreate = res.has_add_role;

          this.$nextTick(() => {
            this.waiting = false;
          })
        }
      });
    },
    generateSearchs(data) {
      const types = data.map(i => {
        return {
          name: i.title,
          code: i.key,
          selected: i.selected
        };
      });

      const filterData = {
        types: types,
        callback: o => {
          this.getSearch(o);
        }
      };

      this.postSearch(filterData);
    },
    // 接收搜索框数据
    getSearch(d) {
      this.searchOptions = d;
      this.page.pageIndex = 1;
      this.getList();
    },
    // 发送搜索框数据
    postSearch(data) {
      this.$emit("filterData", data);
    },
    //选中
    selectChecker(i) {
      this.$set(i, "checked", !i.checked);
    },
    //全选
    selectAllChecker() {
      this.list.forEach(i => {
        this.$set(i, "checked", !this.checkedAll);
      });
      this.checkedAll = !this.checkedAll;
    },
    async handleInterviews(ids, status) {
      let msg = "确认通过吗？";
      if (status === 1) {
        msg = "确认退回吗？";
      }
      const c = await this.$confirm(msg);
      if (!c) return;

      const info = {
        id: ids.join(","),
        status: status
      };

      common.myFetch(apis.publishVerify, info).then(data => {
        if (data) {
          this.checkedAll = false;
          this.$toast(data);
          this.getList();
        }
      });
    },
    async handleInterview(id, status) {
      let msg = "确认通过吗？";
      if (status === 1) {
        msg = "确认退回吗？";
      }
      const c = await this.$confirm(msg);
      if (!c) return;

      const info = {
        id: id,
        status: status
      };

      common.myFetch(apis.publishVerify, info).then(data => {
        if (data) {
          this.$toast(data);
          this.getList();
        }
      });
    },
    allChecks() {
      const selected = [];
      this.list.forEach(i => {
        if (i["checked"]) {
          selected.push(i.publish_id);
        }
      });

      return selected;
    },
    //通过
    upload(id) {
      this.handleInterview(id, 0);
    },
    //退回
    sendBack(id) {
      this.handleInterview(id, 1);
    },
    //批量通过
    banChecks() {
      const ids = this.allChecks();
      this.handleInterviews(ids, 1);
    },
    // 批量退回
    approveChecks() {
      const ids = this.allChecks();
      this.handleInterviews(ids, 0);
    }
  },
  mounted() {
    this.getList('noKeyWord');
  }
};
</script>

<style lang="less" src="@assets/css/publish/publishAudit.less" scoped>
</style>
